module.exports = __webpack_public_path__ + "img/credit-card.86b60f70.svg";